module.exports = __webpack_public_path__ + "lang/de.json";


//////////////////
// WEBPACK FOOTER
// ./lang/de.json
// module id = 114
// module chunks = 3